import { CaseReducer } from '@reduxjs/toolkit';
import { SortOptionsEnum } from 'common/features/VirtualList/VirtualList.config';
import { SortState } from '../../SortGroup/store/sort.types';

export const createSortLeastRecentCaseReducer =
  <State extends SortState>(): CaseReducer<State> =>
  (state) => {
    state.currentSort = SortOptionsEnum.LEAST_RECENT;
  };
